import script from "./AiSubtitles.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiSubtitles.vue?vue&type=script&setup=true&lang=ts"

import "./AiSubtitles.vue?vue&type=style&index=0&id=016712bd&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016712bd"]])

export default __exports__